import React from 'react';

const TrashIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`h-4 w-4 ${className ?? ''}`}
    aria-hidden="true"
  >
    <path
      d="M9 11v6m6-6v6M5 7h14m-1 0-1 12a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 7m2 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TrashIcon;
